import React, { useState } from "react";
import {
    IconButton,
    Menu,
    MenuItem,
    Box,
} from "@mui/material";
import { MoreHorizOutlined } from "@mui/icons-material";

const ActionMenu = ({ onAction = () => { }, menuItems = [] }) => {

    
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        onAction(action); // Callback to handle the action
        handleMenuClose(); // Close the menu
    };

    // const menuItems = [
    //     { label: "View", action: "view" },
    //     { label: "Close", action: "close" },
    //     { label: "Delete", action: "delete" },
    //     { label: "Print", action: "print" },
    // ];

    return (
        <Box>
            <IconButton onClick={handleMenuClick}>
                <MoreHorizOutlined />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {menuItems.map((item) => (
                    <MenuItem
                        key={item.action}
                        onClick={() => handleAction(item.action)}
                        sx={{ fontFamily: "PMe", fontSize: 12, color: "black" }}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default ActionMenu;
